<template>
	<div class="calculator__switch">
		<div
			v-for="option in options"
			:key="option.key"
			class="calculator__switch-option"
			:class="{ 'ln-tooltip': option.hint }"
		>
			<button
				:aria-pressed="option.isSelected"
				class="mdc-button mdc-button--outlined"
				:class="{
					'mdc-button--raised': option.isSelected,
					'ln-tooltip__trigger': option.hint
				}"
				type="button"
				@click="onSwitch(option.key)"
			>
				<!-- <i
					v-if="option.isSelected"
					class="material-icons mdc-button__icon"
					role="presentation"
					>check</i
				> -->
				{{ option.label }}
			</button>

			<span v-if="option.hint" class="ln-tooltip__content">
				{{ option.hint }}
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SwitchButtons',
	props: {
		options: Array,
		onSwitch: Function
	}
};
</script>

<style>
@import url('../assets/css/variables.css');

.calculator__switch {
	display: flex;
}

.calculator__switch .mdc-button {
	min-height: 3rem;
}
.calculator__switch-option:first-child .mdc-button {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}
.calculator__switch-option:last-child .mdc-button {
	margin-left: -1px;
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}

.calculator__switch .mdc-button[aria-pressed='true'] {
	cursor: default;
	box-shadow: none;
}
.calculator__switch .ln-tooltip__content {
	top: 2rem;
}
</style>
